import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AccountsPage from './AccountsPage';
import * as accountActions from "Actions/accountActions";
import { hidePayModal, showPayModal, showPayVeil, hidePayVeil, openPayModal } from "Actions/uiActions";
import * as _ from 'lodash';


const mapStateToProps = state => {
    return {
        accounts: state.accounts.accounts,
        customerCount: state.accounts.customerCount,
        accountMatchBool: state.accounts.accountMatchBool,
		total_amount: state.accounts.total_amount_due,
        showModal: state.ui.showPayModal,
        showPayVeil:state.ui.showPayVeil,
        disablePayModal: state.ui.disablePayModal,
        currentAccount: !_.isEmpty(state.accounts.accounts) ? state.accounts.accounts[state.accounts.currentAccount] : {},
        pcgx:state.accounts.pcgx
    };
}

const mapDispatchToProps = dispatch => {
    return {
        hidePayModal: bindActionCreators(hidePayModal, dispatch),
        accountActions: bindActionCreators(accountActions, dispatch),
        openPayModalFunc: bindActionCreators(openPayModal, dispatch),
        showPayModalFunc: bindActionCreators(showPayModal, dispatch),
        showPayVeilFunc: bindActionCreators(showPayVeil, dispatch),
        hidePayVeilFunc: bindActionCreators(hidePayVeil, dispatch),
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(AccountsPage);



// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/index.js